import React from 'react';
import CRUDManager from '../../../shared/components/crud/CRUDManager';
import { appointmentConfig } from '../config/appointmentConfig';

export default function Appointments() {
  return <CRUDManager config={appointmentConfig} />;
}